import * as React from 'react';
import { type IFalconTheme, Typography, TypographyVariant, useTheme } from '@secretescapes/falcon';
import { useApplicationState } from '@utils/useApplicationState';
import { BullfinchFeatureFlags, useFeatureFlag } from '@utils/useFeatureFlag';
import { Container, Subtitle } from './TitleSection.styles';

interface TitleSectionProps {
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
  theme?: IFalconTheme;
  className?: string;
  onClick?: () => void;
}

export const TitleSection = ({ title, subtitle, className, onClick }: TitleSectionProps) => {
  const { color } = useTheme();
  const { isMobile } = useApplicationState();
  const seoTitleTagsEnabled = useFeatureFlag(BullfinchFeatureFlags.seoTitleTagsEnabled);

  return (
    <Container className={className} isMobile={!!isMobile}>
      <Typography
        variant={TypographyVariant.t3Serif}
        color={color.blackText}
        component={seoTitleTagsEnabled ? 'h2' : 'h1'}
      >
        {title}
      </Typography>
      <Subtitle
        variant={TypographyVariant.body}
        color={color.blackText}
        onClick={onClick}
        component={seoTitleTagsEnabled ? 'h1' : 'h2'}
      >
        {subtitle}
      </Subtitle>
    </Container>
  );
};
